import { DEFAULT_ANY_OPTION } from './constants'

const FILTER_INITIAL_STATE = {
  availability: 'available',
  range: {
    min: DEFAULT_ANY_OPTION,
    max: DEFAULT_ANY_OPTION,
  },
  configurations: {
    bed: {
      min: DEFAULT_ANY_OPTION,
      max: DEFAULT_ANY_OPTION,
    },
    study: {
      min: DEFAULT_ANY_OPTION,
      max: DEFAULT_ANY_OPTION,
    },
    bath: {
      min: DEFAULT_ANY_OPTION,
      max: DEFAULT_ANY_OPTION,
    },
    powderRoom: {
      min: DEFAULT_ANY_OPTION,
      max: DEFAULT_ANY_OPTION,
    },
    car: {
      min: DEFAULT_ANY_OPTION,
      max: DEFAULT_ANY_OPTION,
    },
  },
  aspect: [],
  unitType: DEFAULT_ANY_OPTION,
  showAvailable: false,
  anyLevel: true,
  apply: false,
}

export default FILTER_INITIAL_STATE
